import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';

import ComputedModelStoreClass from 'bundles/course-v2/stores/ComputedModelStore';
import loadCourseDomains from 'bundles/course-v2/utils/loadCourseDomains';
import loadCourseHomeProgress from 'bundles/course-v2/utils/loadCourseHomeProgress';
import loadCourseMaterials from 'bundles/course-v2/utils/loadCourseMaterials';
import loadCourseReferences from 'bundles/course-v2/utils/loadCourseReferences';
import loadCourseSchedule from 'bundles/course-v2/utils/loadCourseSchedule';
import loadS12n from 'bundles/course-v2/utils/loadS12n';

export const loadComputedModels = (
  actionContext: ActionContext,
  { courseSlug, courseId }: { courseSlug: string; courseId: string }
): Q.Promise<any> => {
  if (actionContext.getStore(ComputedModelStoreClass).hasLoaded()) {
    return Q();
  }

  return Q.all([
    loadCourseDomains(actionContext),
    loadS12n(actionContext, courseId),
    loadCourseMaterials(actionContext, courseSlug),
    loadCourseSchedule(actionContext, courseId),
    loadCourseReferences(actionContext, courseId),
    loadCourseHomeProgress(actionContext, courseId),
  ]).then(() => {
    actionContext.dispatch('LOAD_COMPUTED_MODELS');
  });
};
